import React from 'react';
import { Typography } from '@material-ui/core';

import { Box, SuccessPage } from 'components';
import { AccessDeniedImg } from 'assets';

import styles from './styles';

const NotFound = () => {
  const classes = styles();
  return (
    <Box>
      <Box className={classes.notFoundContainerBox}>
        <Box className={classes.boxContent}>
          <SuccessPage
            img={AccessDeniedImg}
            className={classes.accessDeniedImg}
          >
            <Typography
              gutterBottom
              variant="h4"
              className={classes.accessDeniedTxt}
            >
              Access Denied
            </Typography>
          </SuccessPage>
        </Box>
      </Box>
    </Box>
  );
};

export default NotFound;
